import axios from 'axios';
import { API_URL } from '../config';
import { AxiosRequestConfig } from 'axios';

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  permission?: string;
}

type JustificationProfileCreateData = {
  name: string;
  justifications: number[];
  organizational_units?: number[];
  contracts?: number[];
};


export const getJustificationProfiles = async (
  token: string,
  permission: string | null = null,
) => {
  const response = await axios.get(
    `${API_URL}/presenze/company/justification-profiles/`,
    {
      headers: {
        'Authorization': token,
      },
      permission,
    } as CustomAxiosRequestConfig
  );

  return response.data;
};

export const getJustificationProfileDetail = async (
  token: string,
  jpId: number | string,
  permission: string | null = null,
) => {
  const response = await axios.get(
    `${API_URL}/presenze/company/justification-profiles/${jpId}`,
    {
      headers: {
        'Authorization': token,
      },
      permission,
    } as CustomAxiosRequestConfig
  );

  return response.data;
};


export const createJustificationProfile = async (
  token: string,
  data: JustificationProfileCreateData,
  permission: string | null = null,
) => {
  const response = await axios.post(
    `${API_URL}/presenze/company/justification-profiles/`,
    data,
    {
      headers: {
        'Authorization': token,
      },
      permission,
    } as CustomAxiosRequestConfig
  );

  return response.data;
};

export const deleteJustificationProfile = async (
  token: string,
  id: number | string,
  permission: string | null = null,
) => {
  const response = await axios.delete(
    `${API_URL}/presenze/company/justification-profiles/${id}/`,
    {
      headers: {
        'Authorization': token,
      },
      permission,
    } as CustomAxiosRequestConfig
  );

  return response.data;
};

export const updateJustificationProfile = async (
  token: string,
  id: number | string,
  data: JustificationProfileCreateData,
  permission: string | null = null,
) => {
  const response = await axios.patch(
    `${API_URL}/presenze/company/justification-profiles/${id}/`,
    data,
    {
      headers: {
        'Authorization': token,
      },
      permission,
    } as CustomAxiosRequestConfig
  );

  return response.data;
};


export const getOrganizationalUnitJustificationProfile = async (
  token: string,
  ouId: number | string,
  permission: string | null = null,
) => {
  const response = await axios.get(
    `${API_URL}/presenze/company/ous/${ouId}/justification-profile/`,
    {
      headers: {
        'Authorization': token,
      },
      permission,
    } as CustomAxiosRequestConfig
  );

  return response.data;
};

export const updateOrganizationalUnitJustificationProfile = async (
    token: string,
    ouId: number | string,
    profileId: number | string,
    permission: string | null = null,
) => {
    const response = await axios.put(
        `${API_URL}/presenze/company/ous/${ouId}/justification-profile/`,
        {
            profile: profileId,
        },
        {
            headers: {
                'Authorization': token,
            },
            permission,
        } as CustomAxiosRequestConfig
    );

    return response.data;
};

export const deleteOrganizationalUnitJustificationProfile = async (
    token: string,
    ouId: number | string,
    permission: string | null = null,
) => {
    await axios.delete(
        `${API_URL}/presenze/company/ous/${ouId}/justification-profile/`,
        {
            headers: {
                'Authorization': token,
            },
            permission,
        } as CustomAxiosRequestConfig
    );
};
